import { imageNames } from "./imageConstants";

export const viewTypes = {
  CONTACT: "contact",
  COMPANY: "company",
  CUSTOMER: "customer",
  TASK: "task",
  LEAD: "lead",
  DEAL: "deal",
  ENTITY_LIST: "entity_list",
  LIST: "list",
  CAMPAIGN_RECIPIENTS: "campaign_recipients",
  CONTENT: "content",
  ACTION: "action",
  MEETING_LOGS: "meeting_logs",
  CAMPAIGNS_IN_ENGAGE: "campaigns_in_engage",
  SANDBOX: "sandbox",
};

export const accessLevels = {
  EVERYONE: "workspace",
  TEAM: "team_and_users",
  PRIVATE: "personal",
};

export const sharingScopes = {
  WORKSPACE: "workspace",
  TEAM_AND_USERS: "team_and_users",
  PERSONAL: "personal",
};

export const viewLayoutTypes = {
  TABLE: "table",
  BOARD: "board",
};

export const viewTypeOptions = [
  {
    value: "table",
    label: "Table",
    icon: imageNames.TABLE_GREY,
    alt: "table_view",
  },
  {
    value: "board",
    label: "Board",
    icon: imageNames.BOARD_GREY,
    alt: "board_view",
  },
];
